[Uint32Array, Int32Array, Uint8Array, Int8Array].forEach((cls) => {
  if (!cls.prototype.fill) {
    Object.defineProperty(cls.prototype, 'fill', { value: function (value, start, end) {
        start = start || 0;
        end = end || this.length;
        for (var i = start; i < end; i++) {
          this[i] = value;
        }

        return this;
      }, });
  }

  if (!cls.prototype.slice) {
    Object.defineProperty(cls.prototype, 'slice', { value: function (start, end) {
        var i = start === undefined ? 0 : start;
        var finalIdx = end === undefined ? this.length : end;
        var count = finalIdx - i;
        var a = new this.constructor(count);
        var n = 0;
        while (i < finalIdx) {
          a[n] = this[i];
          ++n;
          ++i;
        }

        return a;
      }, });
  }

  if (!cls.prototype.sort) {
    // https://github.com/inexorabletash/polyfill/blob/master/es6.js
    Object.defineProperty(cls.prototype, 'sort', { value: function sort(comparefn) {
      function sortCompare(x, y) {
        // console.assert(Type(x) === 'number' && Type(y) === 'number');
        if (x !== x && y !== y) return +0;
        if (x !== x) return 1;
        if (y !== y) return -1;
        if (comparefn !== undefined) {
          return comparefn(x, y);
        }
        if (x < y) return -1;
        if (x > y) return 1;
        return +0;
      }
      return Array.prototype.sort.call(this, sortCompare);
    }});
  }
});



// WEBPACK FOOTER //
// ./src/polyMesh/generic/utility/polyfill.js